import { HeroImage, HeroSectionContainer, ImageWrapper } from './styles';

export const HeroSection = ({ src }: { src: string }) => {
  return (
    <HeroSectionContainer>
      <ImageWrapper>
        <HeroImage src={src} alt="Hero" />
      </ImageWrapper>
    </HeroSectionContainer>
  );
};

export default HeroSection;
